import { css } from '@adornis/chemistry/directives/css';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog';
import { html } from 'lit';
import { Comment } from '../db/Comment';
import { ContentComment } from '../db/ContentComment';
import { AddComment } from './AddComment';

export const AddCommentDialog = async ({
  relatedEntityID,
  contentID,
  globalSettingsClassName,
}: {
  relatedEntityID: string;
  globalSettingsClassName: string;
  contentID?: string;
}) => {
  return XNativeDialog.showPopup<void>({
    content: (resolve, reject, dialogElement) => {
      return html`
        <x-flex ${css({ width: `800px`, padding: '24px' })} space="md">
          <d-h4> Kommentar hinzufügen </d-h4>
          ${AddComment({
            relatedEntityID: relatedEntityID,
            globalSettingsClassName,
            additionalInfo: contentID ? { contentID } : {},
            commentClass: contentID ? ContentComment : Comment,
            onCreated: () => resolve(),
          })}
        </x-flex>
      `;
    },
  });
};
